
import React from 'react';
import '../../scss/NewInvoice.scss';
import { NewInvoiceProvider } from './newInvoiceProvider';
import NewInvoiceMain from './NewInvoiceMain';
import { WorkflowProvider } from 'components/Workflow/WorkflowContext';

const NewInvoice = ({review = false, view = false}) => {
    return (
        <NewInvoiceProvider  review={review} view={view}>
            <WorkflowProvider  moduleId={3}>
                <NewInvoiceMain review={review} view={view} />
            </WorkflowProvider>
        </NewInvoiceProvider>
    )
};

export default NewInvoice;
